import { WithPaginationPaging } from 'types/pagination'

export const API_PAGINATION_LIMIT = 10
export const API_PAGINATION_OFFSET = 0

/**
 * Helper function for transforming API Reponses with Pagination (Pageable) payloads to Response with `pagination` key in Paging response
 * @returns WithPaginationPaging<WHATEVER_TYPE_SHOULD_BE_IN_CONTENT_KEY>
 */
export const withPaginationPaging = <T>({
  content,
  size,
  number,
  totalElements,
}: {
  content: T
  size: number
  number: number
  totalElements: number
}): WithPaginationPaging<T> => {
  return {
    content,
    pagination: {
      max: size,
      offset: number,
      total: totalElements,
      page: number,
    },
  }
}

/**
 * Estimates a total for slice-paginated endpoints
 * @param {object} params
 * @param {number} params.pageNumber - Zero-based index of the page just fetched.
 * @param {number} params.pageSize - Number of items requested per page.
 * @param {number} params.contentLength - Number of items actually returned in this page.
 * @param {boolean} params.hasNext - Whether the backend reports another page exists.
 * @returns {number} An estimated total when hasNext is true (not the real count - just
 * enough to keep pagination navigable), or the exact total once hasNext is false.
 */
export const estimateSliceTotal = ({
  pageNumber,
  pageSize,
  contentLength,
  hasNext,
}: {
  pageNumber: number
  pageSize: number
  contentLength: number
  hasNext: boolean
}): number => (hasNext ? (pageNumber + 2) * pageSize : pageNumber * pageSize + contentLength)
